import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deletePointForm} from "../store/actions/pointForm";
import {Alert, Button, Spinner} from "reactstrap";


type PointDeleteType = {
    deletePointForm: (id: number) => void
    cancelHandler?: () => void
    id: number
    changeLoading: boolean
    changeError: string
}

class PointDeleteContainer extends Component<PointDeleteType> {

    deleteHandler = () =>{
        const {id, deletePointForm} = this.props;
        deletePointForm(id)
    };

    render() {
        const {changeLoading, changeError, cancelHandler} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler && <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={this.deleteHandler} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner

                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.pointForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deletePointForm
};


export default connect(mapStateToProps, mapDispatchToProps)(PointDeleteContainer);
